export default "__VITE_ASSET__41ef3595__"